<div style="padding-left: 15px; padding-right: 15px; text-align: center;" class="mb-5" [innerHTML]="componentData.content">
</div>
